module.exports = __webpack_public_path__ + "img/amount_paid_icon.60be7626.svg";